// import React from 'react';
// import { Navigate } from 'react-router-dom';
// function ProtectedRoute({ children }) {
//   const token = localStorage.getItem('token');
//   if (!token) {
//     return <Navigate to="/login" replace />;
//   }
//   return children;
// }
// export default ProtectedRoute;
import React from "react";
import { Navigate } from "react-router-dom";
function ProtectedRoute({ children, permissionKey }) {
  const token = localStorage.getItem("token");
  const role = localStorage.getItem("role");
  const storedPermissions = localStorage.getItem("permissions");
  if (!token) {
    return <Navigate to="/login" replace />;
  }
  if (role === "SUPER_ADMIN") {
    return children;
  }
  if (!permissionKey) {
    return children;
  }
  const permissions = storedPermissions
    ? JSON.parse(storedPermissions)
    : {};
  if (permissions[permissionKey] === true) {
    return children;
  }
  return <Navigate to="/" replace />;
}
export default ProtectedRoute;